import * as signalR from "@microsoft/signalr";
import { useState, useEffect } from "react";

const useSignalr = () => {
    const [connection, setConnection] = useState(null);
    const [messages, setMessages] = useState([]);
    const [count, setCount] = useState(0);
    const { token_type, access_token, profile } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};
  
    useEffect(() => {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_MESSAGE_ENDPOINT}/server?access_token=${access_token}`, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .build();
      newConnection
        .start()
        .catch((err) => console.error("Connection failed: ", err));
      setConnection(newConnection);
      return () => {
        newConnection.stop();
      };
    }, []);
  
    useEffect(() => {
      if (connection) {
        //   connection.on('ReceiveMessage', (username, message) => {
        //     setMessages(prevMessages => [...prevMessages, { username, message }]);
        //   });
  
        connection.on("ReceiveMessage", (messages) => {
          setMessages(messages);
        });
  
        connection.on("ExportComplete", (messages) => {
          setMessages(messages);
          let msgcount = count - 1;
          setCount(msgcount);
        });
        connection.on("ExportNotificationCount", (messages) => {
          // setMessages(messages);
          let msgcount = count + 1;
          setCount(msgcount);
        });
      }
    }, [connection]);
    // const sendMessage = (message) => {
    //     if (connection) {
    //         connection.send('newMessage', 'foo', message).then(() => ('Message sent'));
    //     }
    // };
    return { messages, count };
  };
  
  export default useSignalr;